import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { InscripcionTorneoCreadoDTO } from "@/interfaces/Torneo";
  import {
    updateEstadoLista,
  } from "@/services/InscripcionesService";
  import { ref, watch, computed } from "vue";
  import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
  import ModalError from "@/components/Commons/ModalError.vue";
  
  // Definir las propiedades y eventos
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCambiarEstadoListaEquipos',
  props: {
    idInscripcion: {},
    estadoLista: {},
    nick: {},
    isVisible: { type: Boolean }
  },
  emits: ["close", "update:isVisible", "update-inscripcion"],
  setup(__props: any, { emit: __emit }) {

  const props = __props;
  
  const estadoListaLocal = ref(props.estadoLista);

  // ModalDetalleInscripcion.vue
  const emit = __emit;
  
  const visible = computed({
    get: () => props.isVisible,
    set: (val: boolean) => emit("update:isVisible", val),
  });
  const isLoading = ref<boolean>(false);
  
  const estadoListaOptions = [
    "NO ENTREGADA",
    "ENTREGADA",
    "ILEGAL",
    "OK",
  ] as const;
  
  const showSuccessModalLista = ref<boolean>(false);
  const showErrorModal = ref<boolean>(false);
  
  // Registrar el cambio y actualizar en la base de datos
  const logChange = async (
    field: "estadoLista",
    value: string
  ) => {
    isLoading.value = true;
    try {
      //lista
      if (field === "estadoLista") {
        let estado: string;
        if (value == "NO ENTREGADA") estado = "NO ENTREGADA";
        else if (value == "ENTREGADA") estado = "ENTREGADA";
        else if (value == "ILEGAL") estado = "ILEGAL";
        else estado = "OK";
        await updateEstadoLista({
          idInscripcion: props.idInscripcion,
          estadoLista: estado,
        });
        showSuccessModalLista.value = true;
        isLoading.value = false;
        emit("update-inscripcion", { field, value: estado });
  
        
      } 
    } catch (error) {
      console.error(`Error actualizando ${field}:`, error);
      showErrorModal.value = true;
      isLoading.value = false;
    } finally {
      isLoading.value = false;
    }
  };
  
  watch(
    () => estadoListaLocal.value,
    (newValue, oldValue) => {
      if (newValue !== oldValue) {
        logChange("estadoLista", newValue!);
      }
    }
  );
  
  const close = () => {
    visible.value = false; // <-- Emite hacia el padre
    emit("close");
  };

    
  
return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(props.nick), 1),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: close,
                  class: "close-button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" LISTA ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_select, {
                              modelValue: estadoListaLocal.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((estadoListaLocal).value = $event)),
                              items: estadoListaOptions,
                              label: "Estado",
                              dense: "",
                              "hide-details": "",
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (
                    logChange('estadoLista', estadoListaLocal.value!)
                  ))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalLista.value,
      message: "Estado de la lista actualizado.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isLoading).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})